import styled from 'styled-components'
import { colors } from "../../branding";

export const StyledSubhero = styled.header`
  height: auto;
  //min-height: 90vh;
  width: 100%;
  max-width: var(--app-width);
  display: flex;
  color: ${colors.light};
  padding: var(--content-padding-md);
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 20px auto;


  .Hero-content-section {
    /*max-width: 600px;*/
    width:100%;
    font-size: 16px;
    font-weight: normal;
    line-height: 1.6em;

    .Backtohome { 
      color:#fff;
      text-decoration: none;
      font-size: 25px;
    }
    .Hero-text{
      clear: both;
      text-align: center;
      padding-top: 20px;

      h1 {
        font-size: 30px;
        font-weight: normal;
        line-height: 1em;
      }
      .main-title{
        text-align: left;
        font-size: 20px;
      }
      .main-list{
        text-align: left;
        padding-left: 17px;
      }
    }
    

    .Hero-buttons {
      display: flex;
      justify-content: start;
      padding: 5px;
      float: right;

      button {
        background-color: ${colors.pinkLight};
        background-image: linear-gradient(to top right, ${colors.pink} 50%, ${colors.pinkLight} 100%);
        border-radius: 3px;
        color: ${colors.light};
        font-weight: bold;
        transition: all ease-in 200ms;
        max-width: 600px;
        padding: 15px 25px;
        margin-right: 10px;
      }

      button:hover,
      button:active,
      button:focus {
        transform: scale(1.05);
      }
    }

    .Hero-buttons {
      display: flex;
      justify-content: start;
      padding: 5px;

      .button {
        background-color: ${colors.pinkLight};
        background-image: linear-gradient(to top right, ${colors.pink} 50%, ${colors.pinkLight} 100%);
        border-radius: 3px;
        color: ${colors.light};
        font-weight: bold;
        transition: all ease-in 200ms;
        max-width: 600px;
        padding: 15px 25px;
        margin-right: 10px;
        text-decoration: none;
      }

      .button:hover,
      .button:active,
      .button:focus {
        transform: scale(1.05);
      }
    }
  }

  .Hero-cta-section {
    display: flex;
    padding: 0;
    margin-left: 10px;
    height: 200px;
    width: 300px;

    button {
      width: 300px;
      height: 200px;
      transition: all 0.2s ease-in-out 0s;
      cursor: pointer;
      display: flex;
      align-items: center;
      text-align: left;

      svg {
        path {
          fill: url("#instant-trial-button-gradient");
        }
      }

      span {
        overflow: hidden;
        position: absolute;
        font-family: 'Exo', sans-serif;
        font-size: 16px;
        font-weight: bold;
        color: ${colors.light};
        white-space: nowrap;
        width: 200px;
        margin-left: 20px;
      }
    }

    button:hover,
    button:active,
    button:focus {
      transform: scale(1.03);
    }
  }

  @media (max-width: 920px) {
    flex-direction: column;

    .Hero-content-section {
      ul {
        text-align: center;
        padding: 0;
      }

      .Hero-buttons {
        justify-content: center;
      }
    }

    .Hero-cta-section {
      margin-top: 30px;
    }
  }

  @media (max-width: 600px) {
    padding: 10px 5px;
    width: auto;

    
    .Hero-content-section {
      width: auto;
      padding: 10px 0;
      
      .Hero-text {
        h1 {
          font-size: 24px;
        }
        .Backtohome { 
          color:#fff;
        }
      }

      .Hero-buttons {
        button {
          font-size: 12px;
          max-width: 200px;
          padding: 10px 5px;
          margin: 0 5px 0 0;
        }
      }
    }

    .Hero-cta-section {
      width: auto;
      height: 134px;
      padding: 0;
      justify-content: center;

      button {
        width: 200px;
        height: 134px;

        span {
          font-size: 12px;
        }
      }
    }
  }

  @media (max-width: 300px) {
    
    
  }
`
